module.exports = __webpack_public_path__ + "img/hongbao1.39a4fce6.png";